/**
 * Section C Service - C.計入期說明
 * Start date, crediting period type and duration
 */
import axios from '../api/axios';

const BASE_URL = '/api/section-c';

export interface SectionCDetail {
  id: number;
  organization_id: number;
  project_id: number;
  project_start_date:        string | null;
  project_descript:          string | null;
  operational_lifetime:      number | null;
  crediting_period_type:     number | null;  // 1=Renewable, 2=Fixed
  crediting_period_start:    string | null;
  crediting_period_duration: number | null;
  file_attachments_id:       number | null;
  section_c: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface SectionCUpdate {
  project_start_date?:        string | null;
  project_descript?:          string | null;
  operational_lifetime?:      number | null;
  crediting_period_type?:     number | null;
  crediting_period_start?:    string | null;
  crediting_period_duration?: number | null;
  file_attachments_id?:       number | null;
}

export const getSectionCByProject = async (projectId: number): Promise<SectionCDetail | null> => {
  const res = await axios.get<SectionCDetail>(`${BASE_URL}/by-project/${projectId}`);
  return res.data;
};

export const saveSectionC = async (projectId: number, payload: SectionCUpdate): Promise<SectionCDetail> => {
  const res = await axios.put<SectionCDetail>(`${BASE_URL}/${projectId}`, payload);
  return res.data;
};

export const resetSectionC = async (projectId: number): Promise<void> => {
  await axios.post(`${BASE_URL}/${projectId}/reset`);
};

const sectionCService = { getSectionCByProject, saveSectionC, resetSectionC };
export default sectionCService;
